import { useState } from 'react';
import Ad, { AdProps } from '.';

interface Props {
  isVisible: boolean;
}

export default function VisibleAd(props: Props & AdProps): JSX.Element {
  const [viewed, setViewed] = useState(false);

  if (!viewed && props.isVisible) {
    setViewed(true);
  }
  return <Ad load={viewed} {...props} />;
}
